<div class="flex flex-col md:flex-row gap-4 py-4">

    <!-- Columna 1: Lista de recursos -->
    <div class="flex-1 flex flex-col space-y-4 items-center bg-white rounded" style="height: 400px;">

        
        <!-- search  -->
        <div
          class="bg-white rounded-[10px] px-1 flex items-center w-full   mt-4 md:mt-0  border-[1px] shadow-sm border-gray-200">
          <input type="text" placeholder="Buscar por nombre"
            class="flex-grow p-2 focus:outline-none font-[400] text-sm" />
          <button class="bg-white p-2 rounded-r-lg">
            <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
          </button>
        </div>


      <msc-empty-state *ngIf="!loading && resources.length === 0" 
        [title]="'words.resources'"
        [description]="'empty.resources'" 
        [cypressHook]="'resources'">
      </msc-empty-state>
  
      <msc-common-spinner *ngIf="loading"></msc-common-spinner>
  
      <div class="flex flex-col w-full justify-start items-start" 
           *ngIf="!loading && resources.length > 0"
           style="max-height: 350px;">

        <div class=" px-2 rounded shadow-md w-full">
          <msc-shared-resource class="border-b last-of-type:border-b-0"
            *ngFor="let resource of resources; let index=index" 
            [size]="'mini'" 
            [resource]="resource"
            [truncate]="20"
            [downloadIcon]="true"
            (fileUrl)="updateFileUrl($event)"
            >
          </msc-shared-resource>
        </div>
      </div>
    </div>
  
    <!-- Columna 2: Visor PDF -->
    <div class="flex-1  bg-gray-100 flex items-center justify-center h-[80vh] shadow-xl p-6 rounded">
      <pdf-viewer 
        [src]="pdfSrc"
        [render-text]="true"
        [show-all]="true"
        [page]="1"
        [original-size]="true"
        [fit-to-page]="true"
        [zoom]="0.5"
        style="width: 100%; height: 100%; max-width: 450px;">
      </pdf-viewer>
    </div>
  </div>